import Controler from "./Controler";

export default Controler;